import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { useProfileNoteAiSummary } from "hooks";
import { AiSummaryContainer, AiSummaryDisplay } from "components/AiSummary";

/**
 * ProfileNoteAiSummary
 *
 * @param {String}  profileId
 * @param {String}  msgId
 * @param {Boolean} loading
 */
const ProfileNoteAiSummary = ({ profileId, loading, msgId, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data, loading: applicationLoading, error } = useProfileNoteAiSummary({ profileId });

  useEffect(() => {
    setIsLoading(loading || applicationLoading);
  }, [loading, applicationLoading]);

  return (
    <AiSummaryContainer
      title={<FormattedMessage id={msgId} />}
      loading={isLoading}
      data={data}
      error={error}
      hideHeader={!msgId}
      itemRenderer={(item, index, loading) => (
        <AiSummaryDisplay key={index} summary={item?.body} loading={loading} {...props} />
      )}
    />
  );
};

ProfileNoteAiSummary.propTypes = {
  profileId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  msgId: PropTypes.string,
};

export default ProfileNoteAiSummary;
